// import { useControllerModel } from "@/models"
import { getOperationGuide } from "@/api"
import { useRequest } from "ahooks-v2"
import { Tooltip } from "antd"
import { useCallback } from "react"
import type { FC } from "react"
// import IconDark from "./icon-dark.png"
// import IconWhite from "./icon-white.png"
import "./index.scss"

const Operation: FC = () => {
  // const { theme } = useControllerModel()

  // 获取操作指引文件
  const { run: docRun } = useRequest(getOperationGuide, {
    manual: true,
  })

  // 下载
  const downloadDoc = useCallback(() => {
    docRun()
  }, [docRun])

  return (
    <Tooltip title={`点击下载操作提示`}>
      <div
        className="op-icon-wrapper flex flex-center"
        // onClick={() => window.open(`${window.location.origin}/#/operation`, "_blank")}
        onClick={downloadDoc}
      >
        {/* <img
          className="op-icon-img"
          src={theme === "dark" ? IconDark : IconWhite}
          alt=""
          width={22}
          height={22}
        />
        <span className="op-icon-txt">操作手册</span> */}
        <span className="op-icon-txt">?</span>
      </div>
    </Tooltip>
  )
}

export default Operation
